import "../assets/styles/views/change-password.scss";
import { useOutletContext } from "react-router-dom";
import { add_punto_vendita } from "../utils/endpoints";
import { useState } from "react";

export default function AddPuntoVendita() {
    const [context, setContext] = useOutletContext();
    const [password_strength, setPasswordStrength] = useState(0);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!!context.session) {

            let puntoVendita = e.target.puntoVendita.value.trim();
            if (!puntoVendita)
                context.openMessage("danger", "Inserire un punto Vendita Valido");

            let response = await context.httpRequest("post", add_punto_vendita.replace("*", e.target.puntoVendita.value), null,context.session.token);
            if (response.result) {
                context.openMessage("success", "Punto Vendita Aggiunto");
                context.navigateUrl("/account");
            }
            else
                context.openMessage("danger", "Errore associazione Punto Vendita");
        }
    };


    return (
        <section className="change-password mt-md-5 w-100 main-panel p-3">
            <div className="d-flex align-items-center">
                <h1 className="m-0">Aggiungi Punto Vendita</h1>
            </div>
            <form onSubmit={(e) => handleSubmit(e)}>
                <label className="d-block mt-3">CODICE PUNTO VENDITA</label>
                <input name="puntoVendita" type="text" className="w-100" required />
                <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
                    CONFERMA
                </button>
            </form>
        </section>
    );
}
